import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import IconButton from 'atom-components/buttons/icon-button';

type Props = {
  onClick: () => unknown;
  text?: ReactElement;
  className?: string;
};

/**
 * Requires a onClick handler to perform the back action
 * Text can be customised
 * @param props
 * @constructor
 */
export default function BackButton({ text, onClick, className }: Props): ReactElement {
  return (
    <IconButton
      icon="arrow-left"
      text={text || 'Back'}
      outline
      onClick={onClick}
      className={clsx('d-print-none', className)}
    />
  );
}
